import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ProjectionNavbar = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleAuthAction = () => {
    // 跳轉到登錄/註冊頁面（完全獨立的跳轉）
    navigate('/login'); // 或者 '/register'，根據您的路由設置
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <nav
      className='fixed top-0 left-0 right-0 z-50 bg-black'
      style={{ backgroundColor: '#000000' }}
    >
      <div className='flex items-center justify-center px-6 py-4 relative'>
        {/* 左側 - 返回按鈕 */}
        <button
          onClick={handleBackToHome}
          className='absolute left-6 text-white hover:text-gray-300 transition-colors duration-200'
        >
          <svg
            className='w-6 h-6'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M15 19l-7-7 7-7'
            />
          </svg>
        </button>

        {/* 靠近作品左側 - 登錄/註冊按鈕（現代排版，有空間感） */}
        <div className='absolute left-1/4 top-16'>
          <button
            onClick={handleAuthAction}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className='relative text-white hover:text-gray-300 transition-all duration-200 text-left font-mono'
            style={{
              fontFamily:
                'monospace, "Courier New", Consolas, "Liberation Mono", Menlo, Monaco, "Ubuntu Mono"',
              fontSize: '16px',
              letterSpacing: '0.08em',
              lineHeight: '1.4',
            }}
          >
            LOGIN/REGISTER to Upload Your Work
            {/* 下劃線動畫 */}
            <div
              className={`absolute bottom-0 left-0 h-0.5 bg-white transition-all duration-500 ease-out ${
                isHovered ? 'w-full' : 'w-0'
              }`}
              style={{
                transitionProperty: 'width',
                transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default ProjectionNavbar;
